<template>
  <div class="places-autocomplete">
    <div ref="map"></div>
    <div class="tnb-input">
      <label :for="id">{{ label }}</label>
      <input
        :id="id"
        :placeholder="placeholder"
        class="input-text w-full"
        v-model="valueLocal"
        @blur="blurHandler"
        @keyup="keyupHandler"
      />
    </div>
    <ul class="places-autocomplete__results">
      <li
        :class="{ hovered: index === selectedIndex }"
        v-for="(item, index) in predictions"
        :key="item.id"
        v-on:click="selectItem(item)"
      >
        {{ item.address.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";

export default {
  name: "PlacesAutocomplete",
  props: ["value", "id", "label", "placeholder", "onSelect", "onBlur"],
  model: {
    prop: "value",
    event: "valuechange"
  },
  computed: {
    valueLocal: {
      get: function() {
        return this.value;
      },
      set: function(v) {
        this.$emit("valuechange", v);
      }
    }
  },
  data() {
    return {
      //CONFIG VARS
      searchStartAtChar: 5,
      debounceTime: 600,

      //PRIVATE VARS
      hereService: null,
      debouncing: false,
      predictions: [],
      selectedIndex: null
    };
  },
  mounted() {
    this.debouncedGeocode = UtilityService.debounce(
      this.geocodeValue,
      this.debounceTime
    );
  },
  methods: {
    blurHandler() {
      setTimeout(() => {
        this.predictions = [];
        if (this.onBlur) {
          this.onBlur();
        }
      }, 300);
    },

    selectItem(item) {
      console.log("selected", item);
      this.predictions = [];
      this.valueLocal = item.address.label;

      const result = this.mapAndRenameAddressComponents(item.address);
      if (this.onSelect) {
        this.onSelect(result);
      }
      console.log("PLACE DETAILS", result);
    },
    async keyupHandler(event) {
      console.log(event);

      if (
        event.key === "ArrowUp" ||
        event.key === "ArrowDown" ||
        event.key === "Enter"
      ) {
        this.keyboardSelection(event);
        return;
      } else {
        this.selectedIndex = null;
      }

      if (!this.hereService) this.initHereService();

      this.debouncedGeocode();
    },
    geocodeValue() {
      if (this.valueLocal.length < this.searchStartAtChar) {
        return;
      }

      console.log("searching ", this.valueLocal);
      // Call the geocode method with the geocoding parameters,
      // the callback and an error callback function (called if a
      // communication error occurs):
      this.hereService.geocode(
        {
          q: this.valueLocal,
          countryCode: "ITA"
        },
        result => {
          //console.log(result, "result");
          this.displaySuggestions(result);
        },
        error => {
          console.log(error, "error");
        }
      );
    },
    keyboardSelection(event) {
      if (event.key === "ArrowUp" && this.predictions.length > 0) {
        if (this.selectedIndex > 0) {
          this.selectedIndex -= 1;
        } else {
          this.selectedIndex = null;
        }
        console.log(this.selectedIndex);
        return;
      }
      if (event.key === "ArrowDown" && this.predictions.length > 0) {
        if (this.selectedIndex === null) this.selectedIndex = 0;
        else if (
          this.selectedIndex < 4 &&
          this.selectedIndex < this.predictions.length - 1
        ) {
          this.selectedIndex += 1;
        }
        console.log(this.selectedIndex);
        return;
      }

      if (
        event.key === "Enter" &&
        this.predictions.length > 0 &&
        this.selectedIndex !== null
      ) {
        const selectedPlace = this.predictions[this.selectedIndex];
        this.selectItem(selectedPlace);
        return;
      }
    },
    displaySuggestions(predictions) {
      // eslint-disable-next-line no-undef
      if (!predictions || !predictions.items) {
        this.predictions = [];
        return;
      }

      this.predictions = predictions.items;
    },

    async initHereService() {
      // eslint-disable-next-line no-undef
      let platform = await new H.service.Platform({
        apikey: process.env.VUE_APP_API_KEY_HERE
      });

      // Get an instance of the geocoding service:
      this.hereService = platform.getSearchService();
    },

    mapAndRenameAddressComponents(address_components) {
      const fieldsMap = {
        street: "address",
        houseNumber: "houseNumber",
        city: "city",
        countyCode: "province",
        postalCode: "cap",
        countryCode: "country"
      };

      const formattedAddress = {};

      Object.keys(address_components).map(key => {
        const newField = fieldsMap[key];
        if (newField) {
          formattedAddress[newField] = address_components[key];
        }
      });

      formattedAddress.countryCode = "IT";

      return formattedAddress;
    }
  }
};
</script>

<style scoped lang="less">
.places-autocomplete {
  position: relative;
  .tnb-input {
    max-width: none;
  }
  ul.places-autocomplete__results {
    position: absolute;
    background: white;
    width: 100%;
    z-index: 1;
    li {
      padding: 8px;
      border-bottom: 1px solid #e6e6e6;
      border-right: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
      &.hovered,
      &:hover {
        background: #e6e6e6;
        cursor: pointer;
      }
    }
  }
}
</style>
